import { render } from "./StrategyTrades.vue?vue&type=template&id=6f9bc82a"
import script from "./StrategyTrades.vue?vue&type=script&lang=js"
export * from "./StrategyTrades.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__